module.exports = __webpack_public_path__ + "static/pie1-1eb7b440425476389bbf4faa0e0ada7f.png";